export { isPastDate };

const getDateFromToday = (days: number): Date => {
	const now = new Date();
	return new Date(now.setDate(now.getDate() + days));
};

const isPastDate = (date: Date): boolean => {
	return date.getTime() < getDateFromToday(-1).getTime();
};
